import { faLightbulb as fasLightbulb } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface Props {
	variant: "retail" | "corporate" | "bg-retail-new";
	className?: string;
	title?: string;
	icon?: ReactNode;
	children?: ReactNode;
}

export class InfoCard extends React.PureComponent<Props> {
	public static defaultProps: Props = {
		variant: "retail",
		title: "Jobb tudni!",
		icon: <FontAwesomeIcon icon={fasLightbulb} className="mr-2" />,
	};

	public render(): ReactNode {
		const { children, className, title, icon } = this.props;
		const mainClassName = compact([this.getVariantClass(), className]).join(" ");

		return (
			<Card className={mainClassName}>
				<Card.Header>
					<div className="h4 my-1">
						{icon}
						{title}
					</div>
				</Card.Header>
				{children}
			</Card>
		);
	}
	private getVariantClass(): string {
		const { variant } = this.props;
		switch (variant) {
			case "retail":
				return "bg-retail-gradient";
			case "corporate":
				return "bg-corporate-gradient";
			case "bg-retail-new":
				return "bg-retail-gradient-new";
			default:
				return null;
		}
	}
}
